import React from "react";
import { Link as RouterLink } from "react-router-dom";

// REDUX
import { useDispatch } from "react-redux";
import { logoutUser } from "../../store/actions/authSlice";
import { setShowNewCashierModal } from "../../store/actions/cashierSlice"; // Import the action to close the modal
// MATERIAL UI COMPONENTS
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ButtonLinkLikeStyled, ButtonLinkStyled } from "../styled";

// ICONS
import LogoutIcon from "@mui/icons-material/Logout";
import Groups3Icon from "@mui/icons-material/Groups3";
import HistoryIcon from "@mui/icons-material/History";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

export default function CashierLinkTree() {
  const dispatch = useDispatch();

  const handleLinkClick = () => {
    dispatch(setShowNewCashierModal(false));
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(setShowNewCashierModal(false));
  };

  return (
    <>
      <ButtonLinkStyled
        component={RouterLink}
        key="cashier-history-orders"
        to="/historico/pedidos"
        underline="none"
        marginTop={15}
        onClick={handleLinkClick}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <HistoryIcon />
          <Typography variant="subtitle1">Histórico de Pedidos</Typography>
        </Stack>
      </ButtonLinkStyled>
      <ButtonLinkStyled
        component={RouterLink}
        key="cashier-history-delivery"
        to="/historico/entregas"
        underline="none"
        marginTop={15}
        onClick={handleLinkClick}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <DeliveryDiningIcon />
          <Typography variant="subtitle1">Histórico de Caixas</Typography>
        </Stack>
      </ButtonLinkStyled>
      <ButtonLinkStyled
        component={RouterLink}
        key="cashier-customers-link"
        to="/customers"
        underline="none"
        marginTop={15}
        onClick={handleLinkClick}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Groups3Icon />
          <Typography variant="subtitle1">Clientes</Typography>
        </Stack>
      </ButtonLinkStyled>
      <ButtonLinkLikeStyled
        key="cashier-logout-link-like-button"
        onClick={handleLogout}
        marginTop={15}
        fullWidth
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <LogoutIcon />
          <Typography variant="subtitle1">Trocar Operador</Typography>
        </Stack>
      </ButtonLinkLikeStyled>
    </>
  );
}
